import { render, staticRenderFns } from "./TerritoryAreaForm.vue?vue&type=template&id=621fc8a7"
import script from "./TerritoryAreaForm.vue?vue&type=script&lang=js"
export * from "./TerritoryAreaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports